import { render } from "./Table.vue?vue&type=template&id=0790d036&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=0790d036&lang=css&scoped=true"
import "./Table.vue?vue&type=style&index=1&id=0790d036&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0790d036"]])

export default __exports__